<template>
  <div class="row mb-5">
    <nav class="portal_menu">
      <div class="nav nav-tabs" id="nav-tab" role="tablist">
        <router-link
            :to="{ name: 'analyticsUnitsDoneByExternalCoachesPerWeek' }"
            :class="{ active: $route.name === 'analyticsUnitsDoneByExternalCoachesPerWeek' }"
            class="nav-item nav-link"
            role="tab"
            aria-controls="nav-home"
            aria-selected="true">
          Pro Woche
        </router-link>
        <router-link
            :to="{ name: 'analyticsUnitsDoneByExternalCoachesPerMonth' }"
            :class="{ active: $route.name === 'analyticsUnitsDoneByExternalCoachesPerMonth' }"
            class="nav-item nav-link"
            role="tab"
            aria-controls="nav-home"
            aria-selected="true">
          Pro Monat
        </router-link>
      </div>
    </nav>
  </div>
</template>

<script setup>

</script>

<style scoped>

</style>